// extracted by mini-css-extract-plugin
export default {"p_tye":"c7ac192c2c","slcted":"ad44c80bce","slc_color":"e7cf5b2d7a","item_p":"_50b845beb1","r0":"_7510f89893"};